<ng-content> </ng-content>
<svg-icon [key]="icon" [fontSize]="iconSize"></svg-icon>
